import React from "react";
import { usePrefersReducedMotion } from "../theme";

/**
 * The Learn sky: an opaque, painted-feeling backdrop that sits behind every
 * Learn page (hub, course landings). Soft blue-to-cream gradient, a warm sun
 * glow, and a few puffy clouds drifting very slowly. Fixed so it never scrolls
 * away and pages never show the site's dark ground behind translucent cards.
 */
const CLOUD =
  "M20 60c-11 0-20-8-20-18 0-9 7-16 16-17 3-12 14-21 27-21 11 0 21 7 25 17 2-1 5-1 7-1 12 0 22 9 22 20s-10 20-22 20H20z";

const CLOUDS = [
  { w: 420, top: "9%", left: "-6%", dur: 150, delay: -20, o: 0.95 },
  { w: 300, top: "18%", left: "58%", dur: 190, delay: -90, o: 0.8 },
  { w: 520, top: "34%", left: "72%", dur: 230, delay: -40, o: 0.9 },
  { w: 260, top: "48%", left: "12%", dur: 210, delay: -140, o: 0.7 },
  { w: 360, top: "66%", left: "40%", dur: 260, delay: -60, o: 0.75 },
];

export default function LearnSky({ tint = "#EAF6FF", bottom = "#EEF7F0" }) {
  const reduceMotion = usePrefersReducedMotion();
  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed", inset: 0, zIndex: 0, overflow: "hidden", pointerEvents: "none",
        background: `linear-gradient(180deg, #BEE3FF 0%, ${tint} 34%, #F6FAFF 62%, ${bottom} 100%)`,
      }}
    >
      {/* sun glow */}
      <div style={{ position: "absolute", right: "-10%", top: "-18%", width: "46vw", height: "46vw", borderRadius: "50%", background: "radial-gradient(circle, rgba(255,241,190,0.9) 0%, rgba(255,241,190,0.35) 35%, rgba(255,241,190,0) 70%)" }} />
      {CLOUDS.map((c, i) => (
        <svg
          key={i}
          viewBox="0 0 100 60"
          width={c.w}
          height={c.w * 0.6}
          style={{
            position: "absolute", top: c.top, left: c.left, opacity: c.o,
            filter: "drop-shadow(0 12px 18px rgba(11,26,51,0.06))",
            animation: reduceMotion ? "none" : `learn-cloud-drift ${c.dur}s linear ${c.delay}s infinite`,
          }}
        >
          <path d={CLOUD} fill="#fff" />
          <path d={CLOUD} fill="url(#learn-cloud-shade)" opacity="0.5" />
          <defs>
            <linearGradient id="learn-cloud-shade" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="#fff" />
              <stop offset="1" stopColor="#DCEBFF" />
            </linearGradient>
          </defs>
        </svg>
      ))}
      <style>{`
        @keyframes learn-cloud-drift {
          from { transform: translateX(-12vw); }
          to { transform: translateX(112vw); }
        }
      `}</style>
    </div>
  );
}
